import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineInformationCircle } from "react-icons/hi2";
import CircularGauge from "./CircularGauge";
import { getVerdict, getValidatedCount, isGradeIgnored } from "./utils/grade";

const HeroGradeCard = ({ analysis }) => {
  const { t } = useTranslation();
  const overall_grade = analysis?.call_overall_grade;
  const status_label = analysis?.status_label;
  const grading_rule_name = analysis?.grading_rule_name || t("Grille d'évaluation");
  const items = analysis?.items_breakdown || [];

  // Status labels come from `analysis.statusLabels.*`; i18next echoes the key back
  // when a status has no translation, which is our signal to use the generic label.
  const status_key = `analysis.statusLabels.${status_label}`;
  const status_text =
    status_label && t(status_key) !== status_key ? t(status_key) : t("analysis.invalidCall");

  if (isGradeIgnored(overall_grade)) {
    return (
      <div
        className={`rounded-xl border px-4 py-3 flex items-center justify-between ${
          status_label === "internal"
            ? "bg-blue-50/60 border-blue-200"
            : "bg-gray-50/60 border-gray-200"
        }`}
      >
        <div className="flex items-center gap-3">
          <div className="flex justify-center items-center w-8 h-8 rounded-lg bg-gray-100 text-gray-400">
            <HiOutlineInformationCircle size={18} />
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-gray-600">
              {t("analysis.notEvaluated")}
            </span>
            <span className="text-xs text-gray-400">{status_text}</span>
          </div>
        </div>
        <div className="text-[10px] font-medium bg-gray-100 px-2 py-1 rounded-md text-gray-400 tracking-wide uppercase">
          {t("Ignoré")}
        </div>
      </div>
    );
  }

  const { validated, total } = getValidatedCount(items);
  const verdict = getVerdict(overall_grade);

  return (
    <div className="px-4 py-4 rounded-xl border border-success/30 bg-gradient-to-br from-success/5 to-white text-center">
      <div className="flex justify-center mb-3">
        <CircularGauge
          grade={overall_grade}
          size={80}
        />
      </div>
      <div className="text-sm font-semibold text-gray-900">{t(verdict)}</div>
      <div className="text-xs text-gray-500 mt-1">{grading_rule_name}</div>
      {total > 0 && (
        <div className="text-xs text-gray-500 mt-0.5">
          {validated}/{total} {t("critères validés")}
        </div>
      )}
    </div>
  );
};

export default HeroGradeCard;
